module.exports = __webpack_public_path__ + "static/img/mobile.219df9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/download/mobile.png
// module id = p8qU
// module chunks = 3